// featureFlags.ts
export const featureFlags = {
  // Enable or disable the add row button in the TextInput component
  isAddRowEnabled: true,
  // Enable or disable the bounding box text in the `MeasurementsTable` component
  isBBoxEnabled: false,

  // Enable or disable the "More Info" icon in the `NestedUsage` component
  isSheetUsageInfoEnabled: false,
};